import PropTypes from 'prop-types';
import React from 'react';
import './Competitor.css';
import ProgramNumber from '../ProgramNumber/ProgramNumber'

export default function Competitor({
  competitor,
  children,
  showTrainer = false,
  type
}) {

  const {programNumber, scratched, signature} = competitor
  const signatureUpdated = {
    textColor: competitor.signature.text.color,
    backgroundColors: competitor.signature.background.colors,
    backgroundType: competitor.signature.background.type
  }
  const jockeySymbol = (type === "Thoroughbred")? 'J: ' : 'D: '

  return (
    <div className='competitor'>
      {signature && <ProgramNumber programNumber={programNumber} scratched={scratched}  signature={signatureUpdated} />} 
      <div className='nameContainer'>
        <span
          className='name'
        >{`${competitor.postPosition}. ${competitor.name}`}</span>
        <span className='jockey' >
          {competitor.jockey ? `${jockeySymbol} ${competitor.jockey} ` : null}
          {showTrainer && competitor.trainer ? `T: ${competitor.trainer}` : null }
        </span>
      </div>
      {children}
    </div>
  );
}

Competitor.propTypes = {
  competitor: PropTypes.shape().isRequired,
  children: PropTypes.node,
  showTrainer: PropTypes.bool,
  type: PropTypes.string.isRequired
};
